import { Button } from 'design-system/button/Button'
import { DeleteOutlined } from '@ant-design/icons'
import React from 'react'
import { CensusFileRowGridData } from '../../types/census-file-row-grid-data'

type WithdrawOnlySelectedButtonProps = {
  handleClick: () => void
  selectedRows: CensusFileRowGridData[]
  loading: boolean
  buttonText?: string
}

const WithdrawOnlySelectedButton = ({
  handleClick,
  selectedRows,
  loading,
  buttonText,
}: WithdrawOnlySelectedButtonProps) => {
  return (
    <Button
      onClick={handleClick}
      variant="danger"
      size="large"
      loading={loading}
    >
      <DeleteOutlined style={{ marginRight: '8px' }} />
      {loading
        ? 'Withdrawing...'
        : buttonText || `Withdraw (${selectedRows.length})`}
    </Button>
  )
}

export default WithdrawOnlySelectedButton
